import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="P" transform="translate(11.000000, 5.000000)">
        <path
          d="M 5.7 42.48 L 0 42.48 L 0 0.6 Q 2.46 0.3 5.43 0.15 A 120.484 120.484 0 0 1 10.788 0.003 A 133.179 133.179 0 0 1 11.58 0 A 27.575 27.575 0 0 1 15.564 0.273 Q 17.691 0.583 19.483 1.249 A 15.606 15.606 0 0 1 20.46 1.65 Q 24.12 3.3 26.04 6.18 Q 27.96 9.06 27.96 12.78 A 15.155 15.155 0 0 1 27.535 16.454 A 11.561 11.561 0 0 1 25.74 20.4 A 13.387 13.387 0 0 1 21.209 24.378 A 16.839 16.839 0 0 1 19.56 25.17 A 20.865 20.865 0 0 1 14.706 26.504 A 28.316 28.316 0 0 1 10.38 26.82 A 62.414 62.414 0 0 1 7.659 26.763 A 49.757 49.757 0 0 1 5.7 26.64 L 5.7 42.48 Z M 5.7 5.04 L 5.7 21.78 A 28.781 28.781 0 0 0 6.479 21.866 Q 6.828 21.9 7.219 21.931 A 57.754 57.754 0 0 0 8.04 21.99 Q 9.42 22.08 11.1 22.08 Q 16.44 22.08 19.38 19.68 Q 22.32 17.28 22.32 13.26 Q 22.32 9.36 19.5 7.08 A 9.277 9.277 0 0 0 16.452 5.482 Q 15.116 5.056 13.5 4.896 A 20.748 20.748 0 0 0 11.46 4.8 A 78.675 78.675 0 0 0 9.505 4.824 A 65.962 65.962 0 0 0 8.4 4.86 A 54.764 54.764 0 0 0 6.67 4.959 A 45.024 45.024 0 0 0 5.7 5.04 Z"
          fill="currentColor"
          transform='translate(30, 25)'
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
